enum PaymentTypeEnum {
  ADDITIONAL_PAYMENT = 1,
  CREDIT = 2,
}

export default PaymentTypeEnum;
